export default __webpack_public_path__ + "static/media/inapSomos.816252a5.png";